import { Helmet } from "react-helmet-async";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "https://saanswellness.com";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1579165466949-3180a3d056d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function SEO({
  title = "Saans Wellness — Ayurvedic & Nutraceutical PCD Franchise & Manufacturing",
  description = "Saans Wellness offers premium Ayurvedic & nutraceutical PCD franchise with monopoly rights, high margins, free marketing support and WHO-GMP manufacturing. Breathe Better. Live Better.",
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd = [],
}) {
  const url = ORIGIN + path;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Saans Wellness" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}

// ---- Reusable structured-data builders ----
export function organizationSchema() {
  const origin = ORIGIN;
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Saans Wellness",
    alternateName: "Saans Wellness Pvt Ltd",
    url: origin,
    logo: origin + "/favicon.svg",
    slogan: "Breathe Better. Live Better.",
    description: "Ayurvedic & Nutraceutical PCD franchise and manufacturing company.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "30/1 Akash Tower, Arhat Bazaar",
      addressLocality: "Dehradun",
      addressRegion: "Uttarakhand",
      addressCountry: "IN",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-99202-23329",
      email: "wellnesssaans@gmail.com",
      contactType: "sales",
      areaServed: "IN",
      availableLanguage: ["en", "hi"],
    },
  };
}

export function localBusinessSchema() {
  const origin = ORIGIN;
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": origin + "/#business",
    name: "Saans Wellness",
    image: DEFAULT_IMAGE,
    url: origin,
    telephone: "+91-99202-23329",
    email: "wellnesssaans@gmail.com",
    priceRange: "₹₹",
    address: {
      "@type": "PostalAddress",
      streetAddress: "30/1 Akash Tower, Arhat Bazaar",
      addressLocality: "Dehradun",
      addressRegion: "Uttarakhand",
      postalCode: "248001",
      addressCountry: "IN",
    },
  };
}

export function websiteSchema() {
  const origin = ORIGIN;
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Saans Wellness",
    url: origin,
  };
}

export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(([q, a]) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export function productListSchema(products) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: products.map((p, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item: {
        "@type": "Product",
        name: p.name,
        description: p.description,
        image: p.image,
        brand: { "@type": "Brand", name: "Saans Wellness" },
        category: "Ayurvedic & Nutraceutical",
      },
    })),
  };
}
